import _ from "lodash";
import React from "react";

import useLabels from "../../../containers/FacilityDetailsPage/hooks/useLabels";
import useLocation from "../../../containers/FacilityDetailsPage/hooks/useLocation";
import { LabelData } from "../../../models/LabelData";
import OverflowBadge from "../../Common/OverflowBadge";

import "./styles.scss";

export interface ILabelsListProps {
  locationId: number;
  organizationId: string;
}

export const LabelsList: React.FunctionComponent<ILabelsListProps> = (
  props
) => {
  const { organizationId, locationId } = props;

  const { data: labels } = useLabels(
    _.pickBy({
      organization_id: organizationId,
    })
  );
  const { data: locationData } = useLocation(locationId);

  if (!labels || !locationData) {
    return null;
  }

  const attachedLabels = labels.filter((label: LabelData) =>
    locationData.labels.some((l) => l.id === label.id)
  );

  if (attachedLabels.length === 0) {
    return <div className="some-labels">-</div>;
  }

  const [firstLabel, ...restLabels] = attachedLabels;

  return (
    <div className="some-labels">
      <span className="items">{firstLabel.name}</span>
      <OverflowBadge
        count={restLabels.length}
        tooltip={restLabels.map((label) => label.name).join(", ")}
      />
    </div>
  );
};

export default LabelsList;
